import { useEffect, useState } from "react";
import { api } from "../../App";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { pickableContacts, contactLabel } from "../contacts/ContactsTable";

// Client contact picker for RFQs: only the client's Estimator contacts who haven't left
export const RfqContactSelect = ({ clientId, value, onChange }) => {
  const [contacts, setContacts] = useState([]);
  useEffect(() => {
    setContacts([]);
    if (!clientId) return;
    api.get(`/contacts?client_id=${clientId}`).then((r) => setContacts(r.data)).catch(() => {});
  }, [clientId]);
  const options = pickableContacts(contacts, "Estimator", value);
  return (
    <div className="space-y-2">
      <Label className="text-md3-label-large text-gray-700 font-medium">Client Contact (Estimator) *</Label>
      <Select value={value || ""} onValueChange={onChange} disabled={!clientId}>
        <SelectTrigger data-testid="rfqs-client-contact">
          <SelectValue placeholder={clientId ? "Select contact" : "Select a client first"} />
        </SelectTrigger>
        <SelectContent>
          {options.map((c) => (
            <SelectItem key={c.id} value={c.id} disabled={c.is_left} data-testid={`rfqs-contact-option-${c.id}`}>{contactLabel(c)}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {clientId && contacts.length > 0 && options.length === 0 && (
        <p className="text-xs text-red-600" data-testid="rfqs-no-estimator-contacts">No contacts with the "Estimator" role for this client. Add one on the Clients page.</p>
      )}
      {clientId && contacts.length === 0 && (
        <p className="text-xs text-red-600" data-testid="rfqs-no-contacts">This client has no contacts yet. Add an Estimator contact on the Clients page.</p>
      )}
    </div>
  );
};
